import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Swal from 'sweetalert2';
import CustomTable from '../../helpers/custom-table'
import { catchError } from '../../helpers/catch-error'
import DatePicker from "react-datepicker";

import { NavLink } from "react-router-dom";
import { CSVLink } from "react-csv";



const RecordsObtained = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = React.useState({ total_records: 0 });
  var columns = React.useMemo(
    () => [
      {
        accessorFn: row => <a onClick={() => {
          if (row.is_updated == 1)
            updateWorkOrder(row.work_order_id);
        }
        }
          className={row.is_updated == 1 ? "fw-bold text-shadow text-danger" : ""}
          href={"/admin/work-order/" + row.work_order_id} >{row.work_order_no}</a>,
        id: "work_order_id",
        cell: info => info.getValue(),
        header: () => "ID",
        footer: props => props.column.id,
      },
      {
        accessorFn: row => row.patient_last_name + ", " + row.patient_first_name + "__" + row.wo_policy_number,
        id: "patient_policy",
        cell: ({ getValue }) => (
          <span>
            <ul className="table-ul">
              {(getValue().split("__")).map((p, index) => (
                <li key={index}>{p}</li>
              ))}
            </ul>
          </span>
        ),
        header: () => "Patient/Policy#",
        footer: props => props.column.id
      },
      {
        accessorFn: row => row.status == 4 ? "WAITING TO BE INVOICED" :
          (row.status == 5 ? "INVOICE GENERATED" : "PAYMENT(S) RECEIVED"
          ),
        id: "status",
        cell: info => info.getValue(),
        header: () => "Status",
        footer: props => props.column.id
      },
      {
        accessorKey: "copy_date_set_by",
        header: "Copy Date Set By",
        footer: props => props.column.id
      },
      {
        accessorKey: "client_company_name",
        header: "Client",
        footer: props => props.column.id
      },
      {
        accessorKey: "facility_name",
        header: "FACILITY",
        footer: props => props.column.id
      },
      {
        accessorFn: row => <>
          <a onClick={() => copyWorkOrder(row.work_order_id)} href="javascript:void(0)" className="btn btn-link m-0 p-0 me-2">Copy</a>
          <select 
            id="dl_status" 
            name="dl_status" 
            onChange={async (e) => {
              const selectedValue = e.target.value;
              let missingReason = "";

              if (selectedValue === "2") {
                const { value: text, isDismissed } = await Swal.fire({
                  title: 'Reason for Missing Record',
                  input: 'textarea',
                  inputPlaceholder: 'Enter details or missing reasons here...',
                  showCancelButton: true,
                  confirmButtonColor: '#198754',
                  cancelButtonColor: '#dc3545',
                  inputValidator: (value) => {
                    if (!value || !value.trim()) {
                      return 'A valid reason statement is required!';
                    }
                  }
                });

                // Reset the select dropdown index visually if prompt is closed or abandoned
                if (isDismissed || !text) {
                  e.target.value = row.download_status; 
                  return;
                }
                
                missingReason = text.trim();
              }

              updateDownloadStatus(selectedValue, row.work_order_id, missingReason);
            }} 
          >
            <option value="1" selected={row.download_status == 1 ? true : false}>Yes</option>
            <option value="0" selected={row.download_status == 0 ? true : false}>No</option>
            <option value="2" selected={row.download_status == 2 ? true : false}>Missing Record</option>
          </select>
        </>,
        id: "actions",
        cell: info => info.getValue(),
        header: () => "ACTIONS",
        footer: props => props.column.id,
        enableColumnFilter: false,
        enableSorting: false,
       
      
      }


    ],
    []
  )


  const [data, setData] = React.useState(null);
  const [csvData, setCsvData] = React.useState(null);
  const [isBtn, setIsBtn] = React.useState(false);
  const [csvHeader, setCsvHeader] = React.useState([
    { label: "CASE NUMBER", key: "work_order_id" },
    { label: "PATIENT NAME", key: "patient_name" },
    { label: "POLICY NUMBER", key: "wo_policy_number" },
    { label: "CLIENT REFERENCE NUMBER", key: "client_reference_number" },
    { label: "FACIILITY INFORMATION", key: "facility_name" },
    { label: "CLIENT INFORMATION", key: "client_company_name" },
    { label: "INVOICE DATE", key: "invoice_date" },
    { label: "FACILITY FEE", key: "invoice_facility_fee" },
    { label: "CLIENT FEE", key: "invoice_client_fee" },
    { label: "MISC FEE", key: "invoice_misc_fee" },
    { label: "TOTAL FEES", key: "invoice_total" },
    { label: "T/F", key: "is_dollar_40" }
  ]);
  const [woSearch, setWoSearch] = React.useState(null);


  const formatCurrency = (value) => {
    return `$${parseFloat(value || 0).toFixed(2)}`;
  };

  const getWorkOrders = async () => {

    await axios.post(
      process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-records-obtained",
      {},
      { withCredentials: true }
    )
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);
          setCounts({
            total_records: response?.data?.counts?.total_records || response?.data?.work_orders?.length || 0
          });
          setCsvData([]);

          response?.data?.work_orders?.forEach((wo) => {

            const facilityFee = parseFloat(wo?.invoice_facility_fee || 0);
            const clientFee = parseFloat(wo?.invoice_client_fee || 0);
            const miscFee = parseFloat(wo?.invoice_misc_fee || 0);
            const total = facilityFee + clientFee + miscFee;

            let new_wo = {
              work_order_id: wo.work_order_no,
              patient_name: `${wo.patient_last_name}, ${wo.patient_first_name} ${wo.patient_middle_name}`,
              wo_policy_number: wo?.wo_policy_number || "",
              client_reference_number: wo?.client_reference_number || "",
              facility_name: wo.facility_name,
              client_company_name: wo.client_company_name,
              invoice_date: wo.invoice_date,

              invoice_facility_fee: formatCurrency(facilityFee),
              invoice_client_fee: formatCurrency(clientFee),
              invoice_misc_fee: formatCurrency(miscFee),
              invoice_total: formatCurrency(total),

              is_dollar_40: wo.is_dollar_40
            };

            setCsvData((csvData) => [...csvData, new_wo]);
          });

        } else {
          Swal.fire({ icon: "error", title: "Records Obtained Work Order Failed to Load" });
        }

      })
      .catch(function (error) {
        catchError(error, navigate);
      });
  };


  const getWorkOrdersFiltered = async () => {

    setIsBtn(true);

    await axios.post(
      process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-records-obtained",
      woSearch,
      { withCredentials: true }
    )
      .then(function (response) {

        if (response?.data?.status) {

          setData(response?.data?.work_orders);
          setCounts({
            total_records: response?.data?.counts?.total_records || response?.data?.work_orders?.length || 0
          });
          setCsvData([]);

          response?.data?.work_orders?.forEach((wo) => {

            const facilityFee = parseFloat(wo?.invoice_facility_fee || 0);
            const clientFee = parseFloat(wo?.invoice_client_fee || 0);
            const miscFee = parseFloat(wo?.invoice_misc_fee || 0);
            const total = facilityFee + clientFee + miscFee;

            let new_wo = {
              work_order_id: wo.work_order_no,
              patient_name: `${wo.patient_last_name}, ${wo.patient_first_name} ${wo.patient_middle_name}`,
              wo_policy_number: wo?.wo_policy_number,
              client_reference_number: wo?.client_reference_number,
              facility_name: wo.facility_name,
              client_company_name: wo.client_company_name,
              invoice_date: wo.invoice_date,

              invoice_facility_fee: formatCurrency(facilityFee),
              invoice_client_fee: formatCurrency(clientFee),
              invoice_misc_fee: formatCurrency(miscFee),
              invoice_total: formatCurrency(total),

              is_dollar_40: wo.is_dollar_40
            };

            setCsvData((csvData) => [...csvData, new_wo]);
          });

        } else {
          Swal.fire({ icon: "error", title: "Records Obtained Work Order Failed to Load" });
        }

        setIsBtn(false);

      })
      .catch(function (error) {
        setIsBtn(false);
        catchError(error, navigate);
      });
  };

const updateDownloadStatus = async (download_status, work_order_id, missing_reason = "") => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-download-status", {
      download_status: download_status,
      work_order_id: work_order_id,
      missing_reason: missing_reason
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();

        } else {

          Swal.fire({ icon: "error", title: "Unable to update download status" });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });

  }


  const updateWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-is-updated-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();

        } else {

          Swal.fire({ icon: "error", title: "unable to update work order status" });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)
      });


  }



  const copyWorkOrder = async (work_order_id) => {

    await axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/copy-work-order", {
      work_order_id: work_order_id
    }, {
      withCredentials: true
    })
      .then(function (response) {

        if (response?.data?.status) {

          getWorkOrders();
          Swal.fire({ icon: "success", title: "Work order copied successfully. " });

        } else {

          Swal.fire({ icon: "error", title: "Unable to copy work order " });

        }

      })
      .catch(function (error) {

        catchError(error, navigate)

      });


  }



  useEffect(() => {

    getWorkOrders();

  }, []);

  return (
    <>


      <div className="row py-2 start-0 bg-light">

        <div className="col-md-12 col-sm-12 mx-auto text-center">
          <div className="container-fluid z-2  ">

            <span className="btn btn-warning rounded-0 me-1">
              <NavLink className="nav-link" smooth to="/admin/work-orders-active">
                ACTIVE
              </NavLink>
            </span>
            <span className="btn btn-warning rounded-0 me-1">
              <NavLink className="nav-link" smooth to="/admin/work-orders-invoice-needed">
                INVOICE NEEDED
              </NavLink>
            </span>
            <span className="btn btn-success rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-records-obtained">
                RECORDS OBTAINED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-closed">
                CLOSED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-archived">
                ARCHIVED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-canceled">
                CANCELED
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0 me-1 ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-incomplete">
                INCOMPLETE
              </NavLink>
            </span>

            <span className="btn btn-warning rounded-0  ">
              <NavLink className="nav-link" smooth to="/admin/work-orders-missing">
                MISSING
              </NavLink>
            </span>
          </div>
        </div>
      </div>


      <div className="row py-4 start-0  mx-auto ">

        <div className="col-md-6 col-sm-12  ">
          <h3 className="text-dark my-0">RECORD OBTAINED WORK ORDERS</h3>
        </div>

        <div className="col-md-6 col-sm-12 ps-3 text-end">

          <span className="btn btn-primary rounded-0 me-1">
            <NavLink className="nav-link" smooth to="/admin/work-orders-new">
              NEW
            </NavLink>
          </span>
          <span className="btn btn-danger rounded-0  me-1 ">
            <NavLink className="nav-link" smooth to="/admin/work-orders-search">
              SEARCH
            </NavLink>
          </span>

        </div>

      </div>


      <div className="card card-form card-primary mb-3">
        <div className="card-body">
          <form className="form-horizontal form-thick mb-2"  >

            <div className="row px-5 gx-5">

              <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                <label htmlFor="client" >Client</label>
                <input name="client" className="form-control" type="text"
                  value={woSearch?.client}
                  onChange={(e) =>
                    setWoSearch({ ...woSearch, client: e.target.value })
                  }

                />


              </div>
              <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                <label htmlFor="case_manager">Case Manager</label>
                <input name="case_manager" className="form-control" type="text"
                  value={woSearch?.case_manager}
                  onChange={(e) =>
                    setWoSearch({ ...woSearch, case_manager: e.target.value })
                  }
                />
              </div>
              <div className="col-xl-2  col-lg-2 col-sm-12 my-1">
                <label htmlFor="facility">Facility</label>
                <input name="facility" className="form-control" type="text"
                  value={woSearch?.facility}
                  onChange={(e) =>
                    setWoSearch({ ...woSearch, facility: e.target.value })
                  }


                />



              </div>



              <div className="col-xl-2  col-lg-2 col-sm-12 my-1">
                <label htmlFor="invoice_date_range">Invoice From</label>

                <DatePicker name="from" id="from" type="text"
                  className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selectsStart
                  isClearable={true}
                  selected={woSearch?.from}
                  onChange={(e) => {
                    {
                      var dt = new Date(e);

                      const year = dt.getFullYear();
                      const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                      const day = dt.getDate().toString().padStart(2, "0");

                      const formatted_date = month + '/' + day + '/' + year

                      setWoSearch({ ...woSearch, from: formatted_date })

                    }

                  }
                  }
                />
              </div>
              <div className="col-xl-2  col-lg-2 col-sm-12 my-1">
                <label htmlFor="invoice_date_range">Invoice To</label>

                <DatePicker name="to" id="to" type="text"
                  className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selectsEnd
                  isClearable={true}
                  selected={woSearch?.to}
                  onChange={(e) => {
                    {
                      var dt = new Date(e);

                      const year = dt.getFullYear();
                      const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                      const day = dt.getDate().toString().padStart(2, "0");

                      const formatted_date = month + '/' + day + '/' + year

                      setWoSearch({ ...woSearch, to: formatted_date })

                    }
                  }
                  }
                />
              </div>



            </div>


          </form>

        </div>

        <div className="card-footer">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
              <button onClick={() => getWorkOrdersFiltered()} className="btn btn-success mx-1" type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "FILTER"} </button>
              {csvData &&
                <CSVLink data={csvData} headers={csvHeader} className="btn btn-warning mx-1" >Download</CSVLink>
              }
            </div>

          </div>
        </div>
      </div>


      {data &&
        <>
          
          <div className="card border-4 border-dark rounded-1 card-success mb-4" >
<div className="row py-3 px-3 ">
                <div className="col-lg-12">
                    <div className="d-flex justify-content-md-end justify-content-start gap-2">

  <span className="btn btn-outline-success btn-sm">
                        TOTAL RECORDS OBTAINED: <strong>{counts.total_records}</strong>
                      </span>

            </div>
          </div>
  </div>

            <div className="card-body p-0" >
              <CustomTable columns={columns} data={data} />

            </div>
          </div>
        </>

      }
    </>
  );
};

export default RecordsObtained;